import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form';
import { convertUtcDate, toFromDates } from '../components/Common/cleanDates';

import {
    REQUEST_PURCHASE_RETURNS,
    FETCH_PURCHASE_RETURNS_SUCCESS,
    FETCH_PURCHASE_RETURNS_FAILURE,
    SELECT_PURCHASE_RETURN,
    SELECT_VENDOR,
    RESET_CURRENT_PURCHASE_RETURN,
    REQUEST_PURCHASE_RETURN_DETAIL,
    FETCH_PURCHASE_RETURN_DETAIL_SUCCESS,
    FETCH_PURCHASE_RETURN_DETAIL_FAILURE,
    REQUEST_CREATING_PURCHASE_RETURN,
    CREATE_PURCHASE_RETURN_SUCCESS,
    CREATE_PURCHASE_RETURN_FAILURE,
    REQUEST_EDITING_PURCHASE_RETURN,
    EDIT_PURCHASE_RETURN_SUCCESS,
    EDIT_PURCHASE_RETURN_FAILURE,
    COMPLETE_PURCHASE_RETURN,
    COMPLETE_PURCHASE_RETURN_SUCCESS,
    COMPLETE_PURCHASE_RETURN_FAILURE,
    REQUEST_VOID_PURCHASE_RETURN,
    VOID_PURCHASE_RETURN_SUCCESS,
    VOID_PURCHASE_RETURN_FAILURE,
} from './type'

import {
    PURCHASE_RETURNS_URL
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';

export function fetchPurchaseReturns(FromDate, ToDate, days, Status) {
    const dates = toFromDates(days, FromDate, ToDate);
    const fromDate = `?PostingDate__gte=${dates.fromDate}`;
    const toDate = `&PostingDate__lte=${dates.toDate}`;
    const status = (Status && Status !== 'all') ?  `&ReturnStatus=${Status}` : '';
    return dispatch => {
        dispatch(requestPurchaseReturns());
        return axios.get(PURCHASE_RETURNS_URL  + fromDate + toDate + status,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchPurchaseReturnsSuccess(response))
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchPurchaseReturnsFailure(err));
            });
    }
}

export function requestPurchaseReturns() {
    return {
        type: REQUEST_PURCHASE_RETURNS,
    };
}

export function fetchPurchaseReturnsSuccess(purchaseReturns) {
    return {
        type: FETCH_PURCHASE_RETURNS_SUCCESS,
        payload: purchaseReturns
    };
}

export function fetchPurchaseReturnsFailure(error) {
    return {
        type: FETCH_PURCHASE_RETURNS_FAILURE,
        payload: error
    };
}


export function selectPurchaseReturn(purchaseReturn) {
    return {
        type: SELECT_PURCHASE_RETURN,
        payload: purchaseReturn
    };
}

export function selectVendor(vendor) {
    return {
        type: SELECT_VENDOR,
        payload: vendor
    };
}

export function resetCurrentPurchaseReturn() {
    return {
        type: RESET_CURRENT_PURCHASE_RETURN
    }
}

// Fetch the detail page.

export function fetchPurchaseReturnDetail(pr_id, prc_id) {
    return dispatch => {
        dispatch(requestPurchaseReturnDetail());
        if(prc_id) {
          return axios.get(PURCHASE_RETURNS_URL + 'completed/' + prc_id,
              {
                  headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
              }
          )
              .then(response => {
                dispatch(fetchPurchaseReturnDetailSuccess(response));
              }, err => {
                if (err.status === 500 || err.status === 404) {
                  err.data = DEFAULT_ERROR;
                }
                dispatch(fetchPurchaseReturnDetailFailure(err));
              });
        }
        else {
          return axios.get(PURCHASE_RETURNS_URL + pr_id,
              {
                  headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
              }
          )
              .then(response => {
                dispatch(fetchPurchaseReturnDetailSuccess(response));
              }, err => {
                if (err.status === 500 || err.status === 404) {
                  err.data = DEFAULT_ERROR;
                }
                dispatch(fetchPurchaseReturnDetailFailure(err));
              });
        }
    }
}

export function requestPurchaseReturnDetail() {
    return {
        type: REQUEST_PURCHASE_RETURN_DETAIL,
    };
}

export function fetchPurchaseReturnDetailSuccess(purchaseReturnDetail) {
    purchaseReturnDetail = purchaseReturnDetail.data;
    if(purchaseReturnDetail.ReturnDate) purchaseReturnDetail.ReturnDate = convertUtcDate(purchaseReturnDetail.ReturnDate);
    return {
        type: FETCH_PURCHASE_RETURN_DETAIL_SUCCESS,
        payload: purchaseReturnDetail
    };
}

// export function fetchPurchaseReturnCompletedDetail(pr_id) {
//     return dispatch => {
//         dispatch(requestPurchaseReturnCompletedDetail());
//         return axios.get(PURCHASE_RETURNS_URL + pr_id,
//             {
//                 headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
//             }
//         )
//             .then(response => {
//                 dispatch(fetchPurchaseReturnCompletedDetailSuccess(response));
//             })
//             .catch(response => {
//                 dispatch(fetchPurchaseReturnCompletedDetailFailure(response));
//             })
//     }
// }
//
// export function requestPurchaseReturnCompletedDetail() {
//     return {
//         type: REQUEST_PURCHASE_RETURN_DETAIL,
//     };
// }
//
// export function fetchPurchaseReturnCompletedDetailSuccess(purchaseReturnDetail) {
//     purchaseReturnDetail = purchaseReturnDetail.data;
//     if(purchaseReturnDetail.ReturnDate) purchaseReturnDetail.ReturnDate = new Date(purchaseReturnDetail.ReturnDate);
//     return {
//         type: FETCH_PURCHASE_RETURN_DETAIL_SUCCESS,
//         payload: purchaseReturnDetail
//     };
// }

export function fetchPurchaseReturnDetailFailure(error) {
    return {
        type: FETCH_PURCHASE_RETURN_DETAIL_FAILURE,
        payload: error
    };
}

export function createPurchaseReturn({
  PostingDate,
  ReturnReason,
  FinalNetWeight,
  FinalShippingWeight,
  TotalPrice,
  NoteToVendor,
  ReleaseInformation,
  CarryType,
  Discount,
  ShippingCost,
  HandlingCost,
  Adjustment,
  PurchaseStatus,
  MiscCost,
  MiscNote,
  TaxRate,
  PaymentStatus,
  FinalPrice,
  Vendor_id,
  Deliver_VendorDetail_id,
  Pickup_Warehouse_id,
  DispatchMethod_id,
  DispatchOutSourceContact_id,
  Purchaser_User_id,
  Modifier_User_id,
  PaymentTerm_id,
  ShippingMethod,
  MemoNum,
}, Purchase_Return_Line, isPurchaseCredit) {
    // Purchase_Return_Line.map(
    //     product => {
    //         // product.WarehouseBin_id = product.WarehouseBin_id.WarehouseBin_id || product.WarehouseBin_id;
    //         // product.WarehouseZone_id = product.WarehouseZone_id.WarehouseZone_id || product.WarehouseZone_id;
    //         if (product.Product_id)
    //             product.Product_id = product.Product_id.value || product.Product_id;
    //     }
    // )
    if (PostingDate) PostingDate = convertUtcDate(PostingDate);
    if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
    if (PaymentStatus) PaymentStatus = PaymentStatus.value || PaymentStatus;
    if (Deliver_VendorDetail_id) Deliver_VendorDetail_id = Deliver_VendorDetail_id.value || Deliver_VendorDetail_id;
    if (CarryType) CarryType = CarryType.value || CarryType;
    if (ReturnReason) ReturnReason = ReturnReason.value || ReturnReason;
    if (Pickup_Warehouse_id) Pickup_Warehouse_id = Pickup_Warehouse_id.value || Pickup_Warehouse_id;
    if (PaymentTerm_id) PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
    if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;

    return dispatch => {
        dispatch({ type: REQUEST_CREATING_PURCHASE_RETURN });

        return axios.post(PURCHASE_RETURNS_URL,
            {
                Purchase_Return_Line,
                PostingDate,
                ReturnReason,
                TotalPrice,
                NoteToVendor,
                ReleaseInformation,
                CarryType,
                Discount,
                ShippingCost,
                HandlingCost,
                Adjustment,
                PurchaseStatus,
                MiscCost,
                MiscNote,
                TaxRate,
                PaymentStatus,
                FinalPrice,
                Vendor_id,
                Deliver_VendorDetail_id,
                Pickup_Warehouse_id,
                DispatchMethod_id,
                DispatchOutSourceContact_id,
                Purchaser_User_id,
                Modifier_User_id,
                PaymentTerm_id,
                ShippingMethod,
                MemoNum,
                IsPurchaseCredit: isPurchaseCredit,
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
        .then(response => {
          dispatch(createPurchaseReturnSuccess());
          browserHistory.push('/purchaseReturn');
        }, err => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          dispatch(createPurchaseReturnFailure(err));
        });
    }
}

export function createPurchaseReturnSuccess() {
    return {
        type: CREATE_PURCHASE_RETURN_SUCCESS
    }
}

export function createPurchaseReturnFailure(error) {
    return {
        type: CREATE_PURCHASE_RETURN_FAILURE,
        payload: error
    }
}

export function editPurchaseReturn({
    PurchaseReturnCompleted_id,
    PurchaseReturn_id,
    PostingDate,
    ReturnReason,
    FinalNetWeight,
    FinalShippingWeight,
    TotalPrice,
    NoteToVendor,
    ReleaseInformation,
    CarryType,
    Discount,
    ShippingCost,
    HandlingCost,
    Adjustment,
    PurchaseStatus,
    MiscCost,
    MiscNote,
    TaxRate,
    PaymentStatus,
    FinalPrice,
    Vendor_id,
    Deliver_VendorDetail_id,
    Pickup_Warehouse_id,
    DispatchMethod_id,
    DispatchOutSourceContact_id,
    Purchaser_User_id,
    Modifier_User_id,
    PaymentTerm_id,
    ShippingMethod,
    MemoNum,
}, Purchase_Return_Line) {
    FinalShippingWeight = 0;
    Purchase_Return_Line.map(
        product => {
            if(product.WarehouseBin_id) product.WarehouseBin_id = product.WarehouseBin_id.WarehouseBin_id || product.WarehouseBin_id;
            if(product.WarehouseZone_id) product.WarehouseZone_id = product.WarehouseZone_id.WarehouseZone_id || product.WarehouseZone_id;
            if (product.Product_id)
                product.Product_id = product.Product_id.value || product.Product_id;
        }
    )
    if (PostingDate) PostingDate = convertUtcDate(PostingDate);
    if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;
    if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
    if (PaymentStatus) PaymentStatus = PaymentStatus.value || PaymentStatus;
    if (Deliver_VendorDetail_id) Deliver_VendorDetail_id = Deliver_VendorDetail_id.value || Deliver_VendorDetail_id;
    if (CarryType) CarryType = CarryType.value || CarryType;
    if (ReturnReason) ReturnReason = ReturnReason.value || ReturnReason;
    if (Pickup_Warehouse_id) Pickup_Warehouse_id = Pickup_Warehouse_id.value || Pickup_Warehouse_id;
    if(PaymentTerm_id) PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
    if(PurchaseReturnCompleted_id) {
      let Purchase_Return_Line_Completed = Purchase_Return_Line;
      return dispatch => {
          dispatch({ type: REQUEST_EDITING_PURCHASE_RETURN });
          axios.put((PURCHASE_RETURNS_URL + 'completed/' + PurchaseReturnCompleted_id),
              {
                  Purchase_Return_Line_Completed,
                  PostingDate,
                  ReturnReason,
                  FinalNetWeight,
                  FinalShippingWeight,
                  TotalPrice,
                  NoteToVendor,
                  ReleaseInformation,
                  CarryType,
                  Discount,
                  ShippingCost,
                  HandlingCost,
                  Adjustment,
                  PurchaseStatus,
                  MiscCost,
                  MiscNote,
                  TaxRate,
                  PaymentStatus,
                  FinalPrice,
                  Vendor_id,
                  Deliver_VendorDetail_id,
                  Pickup_Warehouse_id,
                  DispatchMethod_id,
                  DispatchOutSourceContact_id,
                  Purchaser_User_id,
                  Modifier_User_id,
                  PaymentTerm_id,
                  MemoNum,
              },
              {
                  headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
              }
          )
              .then(response => {
                dispatch(editPurchaseReturnSuccess());
                browserHistory.push('/purchaseReturn'); // If editd succesfully, refresh the paymentTerm page.
              }, err => {
                if (err.status === 500 || err.status === 404) {
                  err.data = DEFAULT_ERROR;
                }
                dispatch(editPurchaseReturnFailure(err));
              });
      }
    }
    else {
      return dispatch => {
          dispatch({ type: REQUEST_EDITING_PURCHASE_RETURN });
          axios.put((PURCHASE_RETURNS_URL + PurchaseReturn_id),
              {
                  Purchase_Return_Line,
                  PostingDate,
                  ReturnReason,
                  FinalNetWeight,
                  FinalShippingWeight,
                  TotalPrice,
                  NoteToVendor,
                  ReleaseInformation,
                  CarryType,
                  Discount,
                  ShippingCost,
                  HandlingCost,
                  Adjustment,
                  PurchaseStatus,
                  MiscCost,
                  MiscNote,
                  TaxRate,
                  PaymentStatus,
                  FinalPrice,
                  Vendor_id,
                  Deliver_VendorDetail_id,
                  Pickup_Warehouse_id,
                  DispatchMethod_id,
                  DispatchOutSourceContact_id,
                  Purchaser_User_id,
                  Modifier_User_id,
                  PaymentTerm_id,
                  MemoNum,
              },
              {
                  headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
              }
          )
              .then(response => {
                dispatch(editPurchaseReturnSuccess());
                browserHistory.push('/purchaseReturn'); // If editd succesfully, refresh the paymentTerm page.
              }, err => {
                if (err.status === 500 || err.status === 404) {
                  err.data = DEFAULT_ERROR;
                }
                dispatch(editPurchaseReturnFailure(err));
              });
      }
    }
}

export function editPurchaseReturnSuccess() {
    return {
        type: EDIT_PURCHASE_RETURN_SUCCESS
    }
}

export function editPurchaseReturnFailure(error) {
    return {
        type: EDIT_PURCHASE_RETURN_FAILURE,
        payload: error
    }
}

export function completePurchaseReturn(pr_id) {
  return dispatch => {
      dispatch({type: COMPLETE_PURCHASE_RETURN});
      return axios.get(PURCHASE_RETURNS_URL + 'open/' + pr_id,
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(completePurchaseReturnSuccess());
            browserHistory.push('/purchaseReturn');
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            dispatch(completePurchaseReturnFailure(err));
          });
  }
}

export function completePurchaseReturnSuccess() {
    return {
        type: COMPLETE_PURCHASE_RETURN_SUCCESS
    }
}

export function completePurchaseReturnFailure(response) {
    return {
        type: COMPLETE_PURCHASE_RETURN_FAILURE,
        payload: response
    }
}


function voidPurchaseReturnSuccess() {
  return {
    type: VOID_PURCHASE_RETURN_SUCCESS,
  };
}

function voidPurchaseReturnFailure(error) {
  return {
    type: VOID_PURCHASE_RETURN_FAILURE,
    payload: error,
  };
}

export function voidPurchaseReturn(id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_VOID_PURCHASE_RETURN });
    const token = localStorage.getItem('token');
    return axios({
      method: 'delete',
      url: `${PURCHASE_RETURNS_URL}${id}`,
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      dispatch(voidPurchaseReturnSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(voidPurchaseReturnFailure(err));
    });
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/purchaseReturns_actions.js